const doc = [({"ja":({"adminConstantHotelChildrenSettingPriceType":({"percent":"大人料金の割合", "fixedDiscount":"大人料金から指定の金額を割引", "fixed":"固定料金", "free":"無料"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;